import React from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import {
	fireTrackAnalytics,
	ContextualAnalyticsData,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { RouterActions } from '@atlassian/react-resource-router';
import { useIntl } from '@atlassian/jira-intl';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { profileCardNextLegacySourceName } from '../../common/constants.tsx';
import type { ProfileCardBaseProps } from '../../common/types.tsx';
import { ProfileCardWrapper } from '../../common/ui/profilecard-wrapper/main.tsx';
import { getSpaActions } from '../../common/utils.tsx';
import { ProfileCardLegacyView } from './main.tsx';

export const ProfileCardLegacy = ({ externalProfileClient, actions }: ProfileCardBaseProps) => {
	const intl = useIntl();
	const currentUserAccountId = useAccountId();

	const onLoadError = (error: Error, analyticsEvent?: UIAnalyticsEvent) => {
		if (analyticsEvent) {
			fireTrackAnalytics(
				analyticsEvent,
				`${analyticsEvent.payload.actionSubject} ${analyticsEvent.payload.action}`,
				`${analyticsEvent.payload.actionSubject}${analyticsEvent.payload.action}`,
				{
					error,
				},
			);
		}
	};

	return (
		<ContextualAnalyticsData sourceType={SCREEN} sourceName={profileCardNextLegacySourceName}>
			<ProfileCardWrapper externalProfileClient={externalProfileClient} onLoadError={onLoadError}>
				{currentUserAccountId ? (
					<LegacyProfileCardStyled>
						<RouterActions>
							{({ push }) => (
								<ProfileCardLegacyView
									onGetActions={(accountId: string, onActionCleanup?: () => void) =>
										getSpaActions(accountId, intl, push, actions, onActionCleanup)
									}
									onProfileClick={(profileAccountId) => push(`/jira/people/${profileAccountId}`)}
								/>
							)}
						</RouterActions>
					</LegacyProfileCardStyled>
				) : null}
			</ProfileCardWrapper>
		</ContextualAnalyticsData>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LegacyProfileCardStyled = styled.div({
	position: 'relative',
	zIndex: 100,
});
